import React from 'react'
import { IconHeart } from '@tabler/icons-react'

import './styles/say.css'

function Say() {

    const comentarios = [
        {
            comment: "¡Increíble app! Me ha ayudado a encontrar oportunidades laborales que se ajustan perfectamente a mis habilidades y experiencia. Gracias a ella, he conseguido varias entrevistas y estoy seguro de que pronto encontraré el trabajo de mis sueños.",
            user: "Juan Pérez",
            posicion: "Desarrollador Web"
        },
        {
            comment: "Llevaba meses buscando trabajo sin éxito, pero todo cambió cuando descubrí esta app. En menos de una semana, recibí varias ofertas de trabajo y pude elegir la que mejor se adaptaba a mis necesidades. ¡Estoy muy agradecido!",
            user: "María García",
            posicion: "Diseñador Gráfico"
        },
        {
            comment: "Esta aplicación es genial. Antes, me costaba mucho encontrar trabajo como obrero, pero gracias a ella, ahora tengo oportunidades constantes. ¡La recomiendo a todos!",
            user: "Luis Ramírez",
            posicion: "Obrero"
        }
    ];    

    return (

        <section className='--say'>

            <div className='--tit'>
                <h2>
                    <span className='--txt'>Lo que dicen nuestros clientes </span>
                    <span className='--txt'>sobre <span className='--logo'>Chambita</span></span>
                </h2>
            </div>

            <div className='--grd-comments'>

                {comentarios.map((comment, i) => (
                    <div className='--comment' key={i}>
                        <p>{comment.comment}</p>
                        <div className='--line'></div>
                        <div className='--foot'>
                            <div className='--row-A'>
                                <div className='--figure'></div>
                                <div className='--texto'>
                                    <h4>{comment.user}</h4>
                                    <span>{comment.posicion}</span>
                                </div>
                            </div>
                            <div className='--row-B'>
                                <button className='--btn-heart'><IconHeart/></button>
                            </div>
                        </div>
                    </div>
                ))}

            </div>

        </section>

    )

}

export default Say